import React, { useState, useContext, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles({
  forgottenButton: {
    color: '#0C4C35',
    border: '1px solid #0C4C35',
    '&:hover': {
      color: '#63D764',
      border: '1px solid #63D764',
    },
    marginTop: 0,
    marginLeft: 10,
    padding: '2px 15px 2px 15px',
  },
});

export default function ForgottenButton(props) {
  const classes = useStyles();
  const {onClick} = props;

  return (
    <div>
      <Button href="/forgotten-password" className={classes.forgottenButton} variant="outlined" onClick={onClick} >
        <Box p={1} fontWeight="fontWeightBold" fontSize={10}>Forgotten password?</Box>
      </Button>
    </div>
  );
}